import React, { useState } from "react";
import styles from "./BannerRow2.module.css";

interface Banner {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  image?: string;
  url?: string;
  urlMetaTitle?: string;
}

interface BannerRow2Props {
  banners: Banner[];
}

const BannerRow2: React.FC<BannerRow2Props> = ({ banners }) => {
  // Track image loading to prevent layout shift
  const [imagesLoaded, setImagesLoaded] = useState<boolean[]>([]);

  // Ensure we have exactly 2 banners, or don't render
  if (!banners || banners.length !== 2) {
    return null;
  }

  const handleImageLoad = (index: number) => {
    setImagesLoaded((prev) => {
      const newState = [...prev];
      newState[index] = true;
      return newState;
    });
  };

  return (
    <section className={styles.bannerRow}>
      {banners.map((banner, index) => (
        <div key={index} className={styles.bannerContainer}>
          {banner.url ? (
            <a
              href={banner.url}
              title={
                banner.urlMetaTitle || banner.title || `Banner ${index + 1}`
              }
              className={styles.bannerLink}
            >
              <div className={styles.banner}>
                {banner.image && (
                  <img
                    src={banner.image}
                    alt={banner.title || `Banner ${index + 1}`}
                    title={banner.title || `Promoción especial ${index + 1}`}
                    className={styles.bannerImage}
                    aria-label={
                      banner.title || `Promotional banner ${index + 1}`
                    }
                    width={696}
                    height={448}
                    onLoad={() => handleImageLoad(index)}
                    loading="lazy" // Add lazy loading
                  />
                )}
                <div className={styles.bannerContent}>
                  {banner.title && (
                    <h3 className={styles.bannerTitle}>{banner.title}</h3>
                  )}
                  {banner.subtitle && (
                    <p className={styles.bannerSubtitle}>{banner.subtitle}</p>
                  )}
                  {banner.buttonText && (
                    <button className={styles.bannerButton} tabIndex={-1}>
                      {banner.buttonText}
                    </button>
                  )}
                </div>
              </div>
            </a>
          ) : (
            <div className={styles.banner}>
              {banner.image && (
                <img
                  src={banner.image}
                  alt={banner.title || `Banner ${index + 1}`}
                  title={banner.title || `Promoción especial ${index + 1}`}
                  className={styles.bannerImage}
                  aria-label={banner.title || `Promotional banner ${index + 1}`}
                  width={696}
                  height={448}
                  onLoad={() => handleImageLoad(index)}
                  loading="lazy" // Add lazy loading
                />
              )}
              <div className={styles.bannerContent}>
                {banner.title && (
                  <h3 className={styles.bannerTitle}>{banner.title}</h3>
                )}
                {banner.subtitle && (
                  <p className={styles.bannerSubtitle}>{banner.subtitle}</p>
                )}
                {banner.buttonText && (
                  <button className={styles.bannerButton}>
                    {banner.buttonText}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </section>
  );
};

export default BannerRow2;
